export const defaultDesingItems = {
  background: 'url("http://testb.roomster.com.ua/api/v1/attachment/download/46d5236d-3d52-4fdb-88ef-4d5923ae75e7.png") transparent no-repeat bottom center/cover',
  colors: {
    primary: "#ffc329",
    secondary: "#e8e7f1",
    text: "#2d2d4b",
    outside: "#2d2d4b",
    button: "#6f581d",
  },
  bookBtn: {
    background: "white",
    radius: "42",
    color: "#2d2d4b",
    icon: "#2d2d4b",
    border: true,
  },
  payBtn: {
    background: "#2d2d4b",
    radius: "42",
    color: "#ffffff",
    icon: "#ffffff",
    border: false,
  },
  recommend: {
    color: "#ffffff",
    background: "#000000",
  },
  lastImg: "http://testb.roomster.com.ua/api/v1/attachment/download/64603da6-245b-4089-ba07-301272655ac5.png",
};

export const rateTypeOptions = (t = () => "") => [
  {
    value: "rate",
    name: t("ORDINARY_RATE"),
  },
  {
    value: "discountRate",
    name: t("BASAD_ON_EXISTING_RATE"),
  },
];

export const paymentMethods = (t = () => "") => [
  { label: t("CASH"), value: "CASH" },
  { label: t("TERMINAL"), value: "TERMINAL" },
  { label: t("CASHLESS_PAYMENT"), value: "CASHLESS_PAYMENT" },
];

export const dealerOptions = (t = () => "") => [
  { label: t("BOOKING_MODULE"), value: "BOOKING_MODULE" },
  { label: t("DIRECT_SALE"), value: "DIRECT_SALE" },
  { label: t("BOOKING"), value: "BOOKING" },
  { label: t("AIRBNB"), value: "AIRBNB" },
  { label: t("HUTSHUB"), value: "HUTSHUB" },
];

export const dayOfWeeks = [{ name: "MONDAY" }, { name: "TUESDAY" }, { name: "WEDNESDAY" }, { name: "THURSDAY" }, { name: "FRIDAY" }, { name: "SATURDAY" }, { name: "SUNDAY" }];
